import { getChromeRuntime } from '../chrome/wrappers';
import { ChromeMessageType, ProcessUrlResponse } from '../types';
import { getVerdict } from '../navigation/verdict';

/**
 * Listen for messages from content script to answer if it's necessary to hide the tab's content or not
 */
export const setupContentHiding = () => {
  getChromeRuntime().onMessage.addListener((message, sender, sendResponse) => {
    // Exclude other messages
    if (message.type !== ChromeMessageType.SHOULD_RESTORE_CONTENT) {
      return;
    }

    // Get the verdict and send message to restore content if is allowed,
    // or otherwise, send message to keep it hidden.
    const tabUrl = sender.url;
    if (tabUrl) {
      getVerdict(tabUrl).then(processedVerdict => {
        if (shouldRestoreTab(processedVerdict.verdict)) {
          sendResponse({ restore: true });
        } else {
          sendResponse({ restore: false });
        }
      });
      return true; // Return true to wait for sending async response
    }

    sendResponse({ restore: true });
    return false; // Return false for sending synchronous response
  });
};

const shouldRestoreTab = (verdict: ProcessUrlResponse) =>
  [ProcessUrlResponse.ALLOW, ProcessUrlResponse.IGNORE].includes(verdict);
